// import StartRating from "components/StartRating/StartRating";
import { Grid } from "@mui/material";
import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { redirect, useLocation, useNavigate } from "react-router-dom";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { convertHoursToDays } from "utils/convertHoursToDisplayString";
import { successAlert } from "utils/alertHandler";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import usePayDone from "hooks/usePayDone";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

export interface PayPageProps {
  className?: string;
}

const PayDonePage: FC<PayPageProps> = ({ className = "" }) => {
  const { inputRef, totalHours, isUploadingPayment, isPaymentUploaded, bookingInfo, _onPaymentUpload }: any = usePayDone();

  const { t } = useTranslation();

  const renderContent = () => {
    return (
      <div className="w-full flex flex-col sm:rounded-2xl sm:border border-neutral-200 dark:border-neutral-700 space-y-8 px-0 sm:p-6 xl:p-8">
        <>
          {bookingInfo ? (
            <>
              {Number(bookingInfo?.net_amount) > 0 ? (
                <>
                  <h2 className="text-3xl lg:text-4xl font-semibold" style={{ textAlign: "center", justifyContent: "center", alignItems: "center", alignContent: "center", marginBottom: "20px" }}>
                    {t("pay_done_pending_title")}
                  </h2>
                  <Grid container direction="column" alignItems="center" justifyContent="center" height={"100px"}>
                    <Grid item width={"60%"}>
                      <img alt="sent" src="https://i.pinimg.com/originals/af/8d/9a/af8d9ac62dd43026957e1cf82a027637.gif" title="Image" />
                    </Grid>
                  </Grid>
                  {/* <span className="text-lg text-neutral-400">{t("payment_alert")}</span>
          <div style={{ marginTop: 20 }}>
            <ButtonPrimary href="/my-profile">{t("payment_goto_my_profile")}</ButtonPrimary>
          </div> */}

                  {isPaymentUploaded !== null && (
                    <>
                      {!isPaymentUploaded ? (
                        <>
                          {
                            <div className="space-y-3 text-center flex flex-col items-center">
                              <ButtonPrimary loading={isUploadingPayment} disabled={false} onClick={() => inputRef.current.click()}>
                                {t("profile_upload_receipt")}
                              </ButtonPrimary>
                              <input onChange={_onPaymentUpload} accept="image/png, image/gif, image/jpeg" multiple={false} ref={inputRef} type="file" hidden />
                            </div>
                          }
                        </>
                      ) : (
                        <>
                          <div className="space-y-3 text-center flex flex-col items-center">
                            <ButtonSecondary disabled={true}>{t("pay_done_pending_admin_action")}</ButtonSecondary>
                          </div>
                        </>
                      )}
                    </>
                  )}
                  <div className="space-y-3 text-center flex flex-col items-center">
                    <p className="text-neutral-500 dark:text-neutral-400">{t("pay_done_upload_payment_title")}</p>
                    <p className="text-neutral-500 dark:text-neutral-400">{t("pay_done_upload_payment_desc")}</p>
                  </div>
                </>
              ) : (
                <>
                  <h2 className="text-3xl lg:text-4xl font-semibold" style={{ textAlign: "center", justifyContent: "center", alignItems: "center", alignContent: "center" }}>
                    {t("pay_done_success_title")} 🎉
                    <Grid container direction="column" alignItems="center" justifyContent="center">
                      <Grid item width={"30%"}>
                        <img alt="success" src="https://d1oco4z2z1fhwp.cloudfront.net/templates/default/18/okok.gif" title="Image" width={"100%"} />
                      </Grid>
                    </Grid>
                  </h2>

                  <div className="space-y-3 text-center flex flex-col items-center">
                    <p className="text-neutral-500 dark:text-neutral-400">{t("pay_done_approved")}</p>
                  </div>
                </>
              )}
              <div className="space-y-6">
                <h3 className="text-2xl font-semibold">{t("pay_done_payment_method")}</h3>

                <div className="mt-6 border border-neutral-200 dark:border-neutral-700 rounded-3xl flex flex-col sm:flex-row divide-y sm:divide-x sm:divide-y-0 divide-neutral-200 dark:divide-neutral-700">
                  <div className="flex-1 p-5 flex space-x-4">
                    <Grid container>
                      <Grid item md={10} sm={10}>
                        <div className="flex flex-col">
                          <span className="text-sm text-neutral-400">{t("payment_method_fps")}</span>
                          <span className="mt-1.5 text-lg font-semibold">165841446</span>
                          <span className="mt-1.5 text-lg ">Wong K** F***</span>
                        </div>
                      </Grid>
                      <Grid item md={2} sm={2} style={{ flex: 1 }}>
                        <CopyToClipboard
                          onCopy={() => {
                            successAlert(t("copied"));
                          }}
                          text="165841446">
                          <Grid container spacing={0} direction="column" alignItems="flex-end" justifyContent="center" textAlign={"center"} style={{ minHeight: "100%" }}>
                            <Grid item xs={3}>
                              <i className="hover text-neutral-400 text-3xl las la-clipboard"></i>
                            </Grid>
                          </Grid>
                        </CopyToClipboard>
                      </Grid>
                    </Grid>
                  </div>
                  <div className="flex-1 p-5 flex space-x-4">
                    <Grid container>
                      <Grid item md={10} sm={10}>
                        <div className="flex flex-col">
                          <span className="text-sm text-neutral-400">{t("payment_method_bank_transfer")}</span>
                          <span className="mt-1.5 text-lg font-semibold">ZA Bank account</span>
                          <span className="mt-1.5 text-lg">8810 0019 5899</span>
                          <span className="mt-1.5 text-lg ">Wong K** F***</span>
                        </div>
                      </Grid>
                      <Grid item md={2} sm={2} style={{ flex: 1 }}>
                        <CopyToClipboard
                          onCopy={() => {
                            successAlert(t("copied"));
                          }}
                          text="881000195899">
                          <Grid container spacing={0} direction="column" alignItems="flex-end" justifyContent="center" textAlign={"center"} style={{ minHeight: "100%" }}>
                            <Grid item xs={3}>
                              <i className="hover text-neutral-400 text-3xl las la-clipboard"></i>
                            </Grid>
                          </Grid>
                        </CopyToClipboard>
                      </Grid>
                    </Grid>
                  </div>
                </div>

                <h3 className="text-2xl font-semibold">{t("checkout_reservation_information")}</h3>
                <div className="flex flex-col space-y-4">
                  <div className="flex text-neutral-6000 dark:text-neutral-300">
                    <span className="flex-1">{t("pay_done_booking_id")}</span>
                    <span className="flex-1 font-medium text-neutral-900 dark:text-neutral-100">#{bookingInfo?.venue_booking_id}</span>
                  </div>
                  <div className="flex text-neutral-6000 dark:text-neutral-300">
                    <span className="flex-1">{t("startTime")}</span>
                    <span className="flex-1 font-medium text-neutral-900 dark:text-neutral-100">{bookingInfo?.start_date_time}</span>
                  </div>
                  <div className="flex text-neutral-6000 dark:text-neutral-300">
                    <span className="flex-1">{t("endTime")}</span>
                    <span className="flex-1 font-medium text-neutral-900 dark:text-neutral-100">{bookingInfo?.end_date_time}</span>
                  </div>
                  <div className="flex justify-between text-neutral-6000 dark:text-neutral-300">
                    <span className="flex-1">{t("totalTime")}</span>
                    <span className="flex-1 font-medium text-neutral-900 dark:text-neutral-100">{convertHoursToDays(totalHours)}</span>
                  </div>
                  {/* <div className="flex justify-between text-neutral-6000 dark:text-neutral-300">
                    <span className="flex-1">{t("profile_card_point_used")}</span>
                    <span className="flex-1 font-medium text-neutral-900 dark:text-neutral-100">{bookingInfo?.point_value}</span>
                  </div> */}
                  <div className="flex justify-between text-neutral-6000 dark:text-neutral-300">
                    <span className="flex-1">{t("total")}</span>
                    <span className="flex-1 font-medium text-neutral-900 dark:text-neutral-100">HKD ${bookingInfo?.net_amount}</span>
                  </div>
                </div>
                <h3 className="text-2xl font-semibold">{t("checkout_contact_title")}</h3>
                <div className="flex flex-col space-y-4">
                  <div className="flex text-neutral-6000 dark:text-neutral-300">
                    <span className="flex-1">{t("checkout_contact_email")}</span>
                    <span className="flex-1 font-medium text-neutral-900 dark:text-neutral-100">{bookingInfo?.contact_email}</span>
                  </div>
                  <div className="flex text-neutral-6000 dark:text-neutral-300">
                    <span className="flex-1">{t("checkout_contact_phone")}</span>
                    <span className="flex-1 font-medium text-neutral-900 dark:text-neutral-100">{bookingInfo?.contact_phone}</span>
                  </div>
                  <div className="flex text-neutral-6000 dark:text-neutral-300">
                    <span className="flex-1">{t("checkout_contact_remarks")}</span>
                    <span className="flex-1 font-medium text-neutral-900 dark:text-neutral-100">{bookingInfo?.remarks}</span>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <ContentLoading />
          )}
        </>
      </div>
    );
  };

  return (
    <div className={`nc-PayPage ${className}`} data-nc-id="PayPage">
      <main className="container mt-11 mb-24 lg:mb-32 ">
        <div className="max-w-4xl mx-auto">{renderContent()}</div>
      </main>
    </div>
  );
};

const ContentLoading = () => {
  return (
    <div
      style={{
        padding: "1rem",
        alignItems: "center",
      }}>
      <Grid container direction="column" alignItems="center" justifyContent="center">
        <Skeleton height={200} width={200} count={1} style={{ alignSelf: "center", marginBottom: "5%" }} />
        <Skeleton height={50} width={360} count={2} style={{ alignSelf: "center", marginBottom: "1%" }} />
      </Grid>
      <Skeleton height={50} width={150} count={1} style={{ alignSelf: "center", marginTop: "5%", marginBottom: "5%" }} />
      <Grid container direction="column" alignItems="center" justifyContent="center">
        <Skeleton height={50} width={360} count={5} style={{ alignSelf: "center", marginBottom: "1%" }} />
      </Grid>
      <Skeleton height={50} width={200} count={1} style={{ alignSelf: "center", marginTop: "5%", marginBottom: "5%" }} />
      <Grid container direction="column" alignItems="center" justifyContent="center">
        <Skeleton height={50} width={360} count={5} style={{ alignSelf: "center", marginBottom: "1%" }} />
      </Grid>
    </div>
  );
};
export default PayDonePage;
